export const URL = "https://lantmannen.addamig.se/api"
